<template>
  <div>
    <div class="container-fluid">
      <div class="page-header">
        <Breadcrumbs main="Digital" title="Sub Category" />
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5>Product Sub Category</h5>
            </div>
            <div class="card-body">
              <div class="btn-popup pull-right">
                <b-button
                  @click="
                    showModal = true
                    selectedItem = {}
                  "
                  variant="primary"
                  >Add Sub Category
                </b-button>
              </div>
              <GlobalCategoryModal
                @formData="formData"
                @onCancel="onCancel"
                @onEdit="onEdit"
                :showModal="showModal"
                :selectedItem="selectedItem"
                :isEdit="isEdit"
                type="subCategory"
              />
              <div class="table-responsive datatable-vue product-physical">
                <b-modal id="modal-2" title="Confirmation" @ok="deleteItem">
                  <p class="my-4">Are you sure!</p>
                </b-modal>
                <b-table
                  striped
                  class="text-center"
                  bordered
                  show-empty
                  stacked="md"
                  head-variant="light"
                  :items="items.data"
                  :fields="tablefields"
                  :filter="filter"
                  :current-page="currentPage"
                  :select-mode="selectMode"
                  @filtered="onFiltered"
                >
                  <template #cell(image)="field">
                    <img
                      height="50px"
                      :src="field.item.image"
                      alt=""
                      width="50px"
                    />
                  </template>
                  <template #cell(actions)="{ item }">
                    <feather
                      type="edit-2"
                      stroke="#3758FD"
                      stroke-width="1"
                      size="18px"
                      fill="#3758FD"
                      stroke-linejoin="round"
                      @click="
                        showModal = true
                        selectedItem = item
                        isEdit = true
                      "
                    >
                    </feather>
                    <feather
                      type="trash"
                      v-b-modal.modal-2
                      @click="selectedItem = item"
                      stroke="#F72E9F"
                      size="18px"
                      fill="#F72E9F"
                    >
                    </feather>
                  </template>
                </b-table>
              </div>
              <b-col md="12" class="my-1 pagination-justify p-0">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="items?.totalRows"
                  :per-page="perPage"
                  aria-controls="my-table"
                  class="mt-4"
                ></b-pagination>
              </b-col>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import statusIcon from '../../components/featherIcons/status-icon.vue'

export default {
  components: { statusIcon },
  data() {
    return {
      tablefields: [
        { key: 'image', label: 'image', sortable: false },
        { key: 'name', label: 'Name', sortable: false },
        { key: 'categoryInfo.name', label: 'Category', sortable: false },
        { key: 'actions' }
      ],

      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      add: false,
      save: false,
      edit: null,
      item: '',
      selectedSku: '',
      index: null,
      selectMode: 'single',
      showModal: false,
      isEdit: false,
      selectedItem: {}
    }
  },
  created() {
    this.$store.dispatch('product/getSubCategoryProduct', {
      page: this.currentPage,
      limit: this.perPage
    })
  },
  computed: {
    ...mapGetters({
      items: 'product/getSubCategoryProduct'
    }),
    sortOptions() {
      // Create an options list from our fields
      return this.tablefields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key }
        })
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
  },
  watch: {
    currentPage(newPage) {
      this.$store.dispatch('product/getSubCategoryProduct', {
        page: newPage,
        limit: this.perPage
      })
    }
  },
  methods: {
    onCancel() {
      this.showModal = false
      this.isEdit = false
    },
    async formData(subCategoryData) {
      const result = await this.$store.dispatch(
        'product/createSubCategory',
        subCategoryData
      )
      if (result.status === 200) {
        this.showModal = false
        this.$store.dispatch('product/getSubCategoryProduct', {
          page: this.currentPage,
          limit: this.perPage
        })
      }
    },
    async deleteItem() {
      const result = await this.$store.dispatch(
        'product/deleteSubCategory',
        this.selectedItem.id
      )
      this.selectedItem = {}
      if (result.status === 200)
        this.$store.dispatch('product/getSubCategoryProduct', {
          page: this.currentPage,
          limit: this.perPage
        })
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    async onEdit(subCategoryData) {
      const result = await this.$store.dispatch(
        'product/updateSubCategory',
        subCategoryData
      )
      if (result.status === 200) {
        this.showModal = false
        this.isEdit = false
        this.$store.dispatch('product/getSubCategoryProduct', {
          page: this.currentPage,
          limit: this.perPage
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
table.text-center * {
  text-align: center;
}
</style>
